import FORMULAS from '../../../../utils/fomulas';
import PIPELINE_STEPS from '../../../../utils/pipeline_steps';
import ColumnActionModel from './column_action_model';
import TableModel from "../../../datasource/table";
import {isNaN} from 'lodash';

export default class EditColumnStepModel extends ColumnActionModel {
    name = 'Edit Column';
    type = PIPELINE_STEPS.EDIT_COLUMN;
    formula = null;
    formulaArgs = {};

    constructor({formula = FORMULAS.ADD, formulaArgs = {}, ...otherProps} = {}) {
        super(otherProps);
        this.formula = formula;
        this.formulaArgs = formulaArgs;
    }

    getDisplay() {
        return this.formula.getLabel({amount: this.formulaArgs.amount});
    }

    setFormula(formula) {
        this.formula = formula;
    }

    setArg(name, value) {
        if (!isNaN(value)) {
            this.formulaArgs[name] = value;
        }
    }

    getArg(name) {
        return this.formulaArgs[name];
    }

    resetArgs() {
        this.formulaArgs = {};
    }

    apply(table) {
        const newTable = new TableModel(table);
        const column = newTable.getColumnById(this.columnId);

        if (!column) {
            return {table, error: true};
        }

        if (!this.formula.validate(this.formulaArgs)) {
            return {before: column.label, table, incomplete: true};
        }

        const newValues = this.formula.apply(column.sample, this.formulaArgs);
        if (!newValues) {
            return {table, error: true};
        }

        column.sample = newValues;
        return {before: column.label, after: this.getDisplay(), table: newTable};
    }
}
